import axios, {AxiosRequestConfig} from 'axios'
import {apiConfig} from './apiConfig'
import {getOidc} from '~/oidc'
import {toast} from 'ui-v2'

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
	filename?: string
	isDownload?: boolean
}

const client = async <T>(
	endpoint: string,
	{
		data = null,
		headers: customHeaders = {},
		method = '',
		responseType = 'json',
		...customConfig
	}: CustomAxiosRequestConfig,
) => {
	const oidc = await getOidc()

	let accessToken = '' //token.accessToken
	const parsedOidc = oidc as unknown as
		| {getTokens: () => Promise<{accessToken: string}>}
		| undefined
	if (parsedOidc?.getTokens) {
		const token = await parsedOidc.getTokens()
		accessToken = token.accessToken
	}
	// const auth0Data = await JSON.parse(
	// 	localStorage.getItem(
	// 		`oidc.user:https://develop.authentication.vahterus.dev/realms/vahterus-sales-cloud:local_keycloak`,
	// 	) ?? '{}',
	// )
	// let accessToken = auth0Data?.body?.access_token
	// if (accessToken == undefined) {
	// 	accessToken = await sec.getAccessTokenSilently()({
	// 		cacheMode: 'on',
	// 		authorizationParams: {
	// 			audience: apiConfig.audience,
	// 			scope: apiConfig.scope,
	// 		},
	// 	})
	// }

	const getHttpMethod = (data: string, method: string) => {
		if (method) return method
		if (data) return 'POST'
		return 'GET'
	}
	const config = {
		url: `${apiConfig.baseUrl}/${endpoint}`,
		method: getHttpMethod(JSON.stringify(data), method),
		responseType: responseType,
		data: data ? data : undefined,
		headers: {
			Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
			'Content-Type':
				Object.keys(customHeaders).includes('Content-Type') ?
					customHeaders['Content-Type']
				: data ? 'application/json'
				: undefined,
			...customHeaders,
		},
		...customConfig,
	}
	return axios<T>(config)
		.then(response => {
			if (response.status === 401) {
				return Promise.reject({message: 'Please re-authenticate.'})
			}

			return response.data
		})
		.catch(error => {
			/*
			Because we have to handle cases when heatExchanger does not have spreadsheet 
			backend returns 400 but we still the page to load without error
			We will return null for this case
			The reason why this block code is here is because it has to be in the lowest level of try catch block.
			*/
			if (
				error.response?.status === 400 &&
				error.response?.data?.message === 'SpreadSheet not found!'
			) {
				console.log('error 400')
				return Promise.resolve(null)
			}
			if (error.response.status === 403) {
				console.log(401)
				console.log(error.response)
				// sec.getLogoutFunc()()
				toast({
					title: 'Permission denied',
					type: 'descriptiveError',
					description: 'You do not have access',
				})
			}
			if (error.response) {
				return Promise.reject(error.response.data)
			} else if (error.request) {
				return Promise.reject(error.request)
			} else {
				return Promise.reject(error.message)
			}
		})
}

/**
 * Same function as `client`, typed without the `null` result: `client` only
 * resolves `null` for document-api's 400 "SpreadSheet not found!" response,
 * which the pricing-api and user-api endpoints called through this never send.
 */
export const nonNullClient = client as <T>(
	endpoint: string,
	config: CustomAxiosRequestConfig,
) => Promise<T>

export default client
